import React, {useState} from 'react';
import {View, StyleSheet, Dimensions} from 'react-native';
import Styles from 'src/components/Styles';
import AccountStore from 'src/stores/AccountStore';
import {FlashList} from '@shopify/flash-list';
import HistorySectionView from './HistorySectionView';
import moment from 'moment';
import AccountConstants from 'src/constants/AccountConstants';
import FirebaseAnalytic from 'src/nativeModules/FirebaseAnalytic';
import AVText from 'src/components/elements/AVText';
import Localized from 'src/constants/AppStrings';
import {NavigationProp} from '@react-navigation/native';
import Settings from 'src/Settings';
import EmptyReceipt from 'src/components/img/EmptyReceipt';
import {useHistory, useRefreshHistory} from './hooks';
import {useSelector} from 'react-redux';
import {RootState} from 'src/redux/store';

export type HistoryComponentProps = {
  historyfilter?: AccountConstants;
  navigation: NavigationProp<HistoryComponentProps>;
};

export const HistoryComponent: React.FC<HistoryComponentProps> = (props) => {
  const [page, setPageNumber] = useState(1);
  const [fundingPage, setFundingPageNumber] = useState(1);
  const {height} = Dimensions.get('window');
  const accountId = useSelector((state: RootState) => state.account.account.id);
  const {isLoading, isRefreshing, setIsRefreshing, history, setStarted} =
    useHistory(props, page, fundingPage, accountId);

  const loadMore = () => {
    if (isRefreshing) {
      return;
    } // Prevent multiple fetches at once

    FirebaseAnalytic.trackEvent('loadMore', 'HistoryComponent', {
      ...props,
    });
    const allItemsList = AccountStore.filteredAndSortedHistory('');
    const getLastItem = allItemsList[allItemsList.length - 1]?.data;

    let hasMoreItems = false;
    if (getLastItem) {
      hasMoreItems = !getLastItem[getLastItem.length - 1].lastItem;
    }
    if (hasMoreItems && !isRefreshing) {
      const pageNumber =
        props.historyfilter === AccountConstants.FUNDING_TYPE ||
        props.historyfilter === AccountConstants.SEND_SNACK ||
        props.historyfilter === AccountConstants.SALE_TYPE ||
        props.historyfilter === AccountConstants.MARKET_PURCHASES ||
        props.historyfilter === AccountConstants.MOBILE_PURCHASES ||
        props.historyfilter === AccountConstants.REFERRAL_TYPE ||
        props.historyfilter === AccountConstants.SIGN_UP_REWARDS ||
        props.historyfilter === AccountConstants.REFERRAL_SIGNUP_TYPE ||
        props.historyfilter === AccountConstants.REDEMPTION_TYPE ||
        props.historyfilter === AccountConstants.ADJUSTMENT_TYPE
          ? fundingPage
          : page;
      onRefresh(pageNumber + 1);
    }
  };

  const onRefresh = async (pageNo: number) => {
    setStarted(moment());
    useRefreshHistory(
      props,
      pageNo,
      accountId,
      setFundingPageNumber,
      setPageNumber,
      setIsRefreshing,
    );
  };

  const getLoadingView = () => {
    return (
      <View style={styles.emptyView}>
        <AVText style={styles.emptyText}>{Localized.Labels.loading}</AVText>
      </View>
    );
  };

  const getEmptyView = () => {
    return (
      <View style={styles.emptyView}>
        <EmptyReceipt />
      </View>
    );
  };
  return (
    <View
      style={[styles.container, Settings.isRefive() && {top: -9}]}
      testID="historyComponentContainer"
    >
      {isLoading && history?.length === 0 && getLoadingView()}
      {!isLoading && history?.length === 0 && getEmptyView()}
      {history?.length !== 0 && (
        <View style={{flex: 1, height: height}}>
          <FlashList
            testID="historyComponentFlashlist"
            data={history}
            keyExtractor={(item, index) => `${item.title}${index.toString()}`}
            renderItem={({item, index}) => (
              <HistorySectionView
                testId={item.title}
                indexNo={`${item.title}${index.toString()}`}
                title={item.title}
                data={item.data}
              />
            )}
            estimatedItemSize={80}
            onRefresh={() => {
              onRefresh(1);
            }}
            refreshing={isRefreshing}
            onEndReached={loadMore}
            onEndReachedThreshold={0.5}
          />
        </View>
      )}
    </View>
  );
};
const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Settings.isRefiveAnd365Pay()
      ? Styles.tabBarBackgroundColor
      : Styles.Colors.Canteen.lightGray,
  },
  item: {
    color: Styles.darkColor,
    flex: 2,
    fontSize: Styles.Fonts.f7,
    fontWeight: '700',
    textTransform: 'capitalize',
  },
  emptyView: {
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
  },
  emptyText: {
    color: Styles.darkColor,
    fontSize: Styles.Fonts.f7,
    fontWeight: '700',
  },
  footerLoader: {
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: 10,
  },
});
